export const listConstant = {
  childHeader: 'Process & Product Audit list',
  addButtonLable: 'New Plan',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW PLAN',
};

export const createConstant = {
  childHeader: 'Process & Product Audit list',
  theadHeader: 'Annual Process & Product Audit Plan for ',
  extracolSpan: 4,
};

export const checkListList = {
  childHeader: 'Process & Product Audit STATUS',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  deleteurl: 'processAndProductAuditPlanRoute',
  gettableDataurl: 'processAndProductAuditPlanRoute/monthly',
  getPlanByid: 'processAndProductAuditPlanRoute',
  createPlanByid: 'processAndProductAuditPlanRoute',
  updatePlanByid: 'processAndProductAuditPlanRoute',
  sync: 'processAndProductAuditPlanRoute/handleSync',
  getAllCheckList: 'processAndProductAuditPlanRoute/getAllCheckList',
  checkListStatus: 'processAndProductAuditPlanRoute/handleStatus',
  checklistUpload: 'processAndProductAuditPlanRoute/handleUpload',
  checklistDeleteImage: 'processAndProductAuditPlanRoute/handleDeleteImage',
  checklistData: 'processAndProductAuditPlanRoute/checklistRoute',
};

export const tilesConstant = {
  childHeaderText: 'Process & Product Audit',
};

export const navigationConstant = {
  createPlanSchedule: '/common/processAndProductAuditPlanCreate',
  createChecklist: '/common/processAndProductAuditChecklistCreate',
};
